<template>
    <div class="login-content-wrapper">
        <div class="img-desktop d-none d-lg-inline-block img-desktop-login"></div>
        <section class="content">
            <div class="container-fluid">
<!--                <div class="login-logo-container">-->
<!--                    <img src="@/assets/img/logoAfflexBaseline.png" alt="Afflex logo">-->
<!--                </div>-->
                <div class="row mt-4">
                    <div class="col-md-6 form-request-content">
                        <div class="request-title">
                            <h1>RÉCUPÉRER MON MOT DE PASSE</h1>
                        </div>
                        <!-- Incorrect email alert -->
                        <div v-show="showErrorMessage"
                             class="alert alert-warning alert-dismissible"
                        >
                            <button type="button"
                                    class="close"
                                    @click="showErrorMessage = !showErrorMessage"
                            >×</button>
                            <h5>
                                <i class="icon fas fa-exclamation-triangle"></i>
                                <span>L'adresse email ne correspond à aucun utilisateur.</span>
                            </h5>
                        </div>
                        <!-- Incorrect email alert -->

                        <form novalidate="novalidate"
                              class="needs-validation"
                        >
                            <p>Un e-mail contenant un lien pour modifier votre mot de passe vous sera envoyé.</p>
                            <!-- Email -->
                            <label class="required-field-asterisks required"
                                   for="email"
                            >Votre adresse email</label>
                            <input type="text"
                                   id="email"
                                   class="form-control form-control-lg"
                                   placeholder="Email"
                                   :class="{ 'is-invalid': $v.formData.email.$error }"
                                   @input="delayTouch($v.formData.email)"
                                   v-model="formData.email"
                            >
                            <FormError error="Format de l'email incorrect"
                                       v-if="!$v.formData.email.email && $v.formData.email.$dirty"
                            ></FormError>
                            <FormError error="Veuillez renseigner l’email"
                                       v-if="!$v.formData.email.required && $v.formData.email.$dirty"
                            ></FormError>
                            <!-- Email -->

                        </form>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto login-btn__wrapper">
                            <router-link tag="button" class="btn btn-success btn-lg ml-4 btn-link btn__save btn-back"
                                         :to="{ name: 'login' }"
                            >Retour à l'écran de connexion</router-link>

                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save btn-link__reset-password"
                                    :disabled="isLoading || $v.$invalid"
                                    @click.prevent="submit"
                            >
                                <span>Valider</span>
                                <ButtonSpinner :isLoading="isLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import FormError from '../../components/FormError';
import ButtonSpinner from '../../components/ButtonSpinner';
import ValidationDelayTouch from '../../mixins/validationDelayTouch';
import { email, required } from 'vuelidate/lib/validators';
import { requestPasswordReset } from '../../service/api/user.api';

export default {
    mixins: [ValidationDelayTouch],
    data() {
        return {
            formData: {
                email: ''
            },
            showErrorMessage: false,
            isLoading: false
        };
    },
    methods: {
        async submit() {
            this.isLoading = true;
            this.showErrorMessage = false;
            try {
                await requestPasswordReset(this.formData);

                this.isLoading = false;
                await this.$router.push({ name: 'success', params: {
                    messageShortCode: 'reset_password_check_email'
                } });
            } catch ({ response }) {
                this.isLoading = false;
                this.showErrorMessage = true;
            }
        }
    },
    validations: {
        formData: {
            email: {
                email,
                required
            }
        }
    },
    components: {
        FormError,
        ButtonSpinner
    }
}
</script>

<style scoped lang="scss">
    p {
        margin-bottom: 0;
    }
</style>
